$(function(){

    $('.notify').each(function(){
        $$.openModal($(this));
    });

});